import axios from 'axios';

const instance = axios.create( {
  baseURL: window.prhReact.restBase,
  headers: {
    common: {
      "X-WP-Nonce": window.prhReact.nonce,
    }
  }
} );

export default instance;



// WEBPACK FOOTER //
// ./src/wp-axios/axios.js